import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_DASHBOARD_NEW_ASSETS = createFcmDetails('starter_dashboard_new_assets', {
	owner: 'axolotl',
	context: 'Petition share visuals new iteration',
	description: `
		Feature release flag that enables new share visuals generation for petitions.
		The petition service only uses the "enabled" value for determining whether to start creating new share visuals for petitions,
		while the frontend uses both "enabled" and the users "locale" to determine whether to show the UI.
	`,
	template: { enabled: true, locales: ['en-US'] },
	import: false,
});
